import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-white pt-5 pb-3">
      <div className="container">
        <div className="row">
          {/* About Company */}
          <div className="col-md-3 mb-3">
            <h4 className="fw-bold mb-3 text-white text-center"><i className="fas fa-chair me-2 text-white"></i> Satish Office Chair Repair</h4>
            <p className="text-secondary text-white">
              Satish Office Chair Repair & Service, we are committed to delivering fast, affordable, and long-lasting repair solutions. Our goal is to extend the life of your office chairs while helping you save the cost of purchasing new furniture. Whether you need a single chair repaired or maintenance for hundreds of office chairs, our expert team is ready to provide dependable doorstep service with quality workmanship.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-3 mb-3">
            <h5 className="fw-bold mb-3 text-white">Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="/" className="text-secondary text-decoration-none hover-primary text-white">Home</a></li>
              <li><a href="/about" className="text-secondary text-decoration-none hover-primary text-white">About Us</a></li>
              <li><a href="/services" className="text-secondary text-decoration-none hover-primary text-white">Our Services</a></li>
              <li><a href="/contact" className="text-secondary text-decoration-none hover-primary text-white">Contact Us</a></li>
            </ul>
          </div>
 {/* Services Links */}
          <div className="col-md-3 mb-3">
            <h5 className="fw-bold mb-3 text-white">Our Services</h5>
            <ul className="list-unstyled text-secondary text-white">
        <li>Office Chair Repair in Pune</li>
        <li>Office Chair Service Pune</li>
        <li>Office Chair Hydraulic Repair</li>
        <li>Office Chair Wheel Replacement</li>
        <li>Executive Chair Repair</li>
        <li>Computer Chair Repair</li>
        <li>Mesh Chair Repair</li>
        <li>Revolving Chair Repair</li>
      <li>Office Chair Spare Parts</li>
        <li>Ergonomic Chair Repair</li>
        <li>Office Chair Maintenance</li>
        <li>Office Chair AMC Pune</li>
        <li>Office Furniture Repair</li>
        <li>Chair Repair Service</li>
        <li>Office Chair Repair Near Me</li>
            </ul>
          </div>
          {/* Contact Info */}
          <div className="col-md-3 mb-3">
            <h5 className="fw-bold mb-3 text-white">Get in Touch</h5>
            <p className="text-secondary text-white"><i className="fas fa-phone-alt me-2"></i> +91 97659 60907</p>
            <p className="text-secondary text-white"><i className="fas fa-envelope me-2"></i> support@satishchairrepair.co.in</p>
            <p className="text-secondary text-white"><i className="fas fa-map-marker-alt me-2"></i> Patil estate lane no.3, Old Mumbai - Pune Hwy, Shivajinagar, Pune, Maharashtra 411005 India

</p>
            
            <div className="social-links mt-3">
              <a href="#" className="text-white me-3"><i className="fab fa-facebook fa-lg"></i></a>
              <a href="#" className="text-white me-3"><i className="fab fa-whatsapp fa-lg"></i></a>
              <a href="#" className="text-white"><i className="fab fa-instagram fa-lg"></i></a>
            </div>
          </div>
        </div>
        
        <hr className="border-secondary mt-4" />
        <div className="text-center text-secondary text-white">
          <small>© 2026 Satish Office Chair Repair. All Rights Reserved.<a href="https://zaintontechnologies.com">Website Design By Zainton Technologies</a> </small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;